"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ArticleBox = _interopRequireDefault(require("../ArticleBox/ArticleBox"));
var _useBreakPoint = require("../../../common/useBreakPoint");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.articleBoxArea-container {\n  max-width: 100%; }\n  .articleBoxArea-container .items {\n    max-width: 1056px;\n    display: flex;\n    flex-wrap: wrap;\n    row-gap: 16px;\n    padding-bottom: 16px; }\n  .articleBoxArea-container .items2 {\n    max-width: 1056px;\n    display: flex;\n    flex-wrap: wrap;\n    row-gap: 16px; }\n\n@media (max-width: 66rem) {\n  .articleBoxArea-container {\n    width: 100%;\n    max-width: 100%; }\n    .articleBoxArea-container .items2 {\n      width: 100%;\n      max-width: 100%;\n      display: grid;\n      grid-template-columns: 1fr 1fr; }\n      .articleBoxArea-container .items2 .item {\n        width: 100%;\n        max-width: 100%; }\n      .articleBoxArea-container .items2 .articleBox-container {\n        width: auto;\n        max-width: 100%; }\n    .articleBoxArea-container .items2.all-equals {\n      grid-template-columns: 1fr; } }\n\n@media (max-width: 42rem) {\n  .articleBoxArea-container {\n    width: 100%; }\n    .articleBoxArea-container .items2 {\n      grid-template-columns: 1fr;\n      width: 100%; }\n      .articleBoxArea-container .items2 .item .articleBox-container {\n        padding-left: opx;\n        border-left: 0px solid #d4d4d4;\n        margin-right: 0px; } }\n";
  const fileName = "ArticleBoxArea_ArticleBoxArea";
  const element = document.querySelector("style[data-sass-component='ArticleBoxArea_ArticleBoxArea']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const ArticleBoxArea = _ref => {
  let {
    items,
    lang,
    translate,
    allEquals = false,
    showTitle = true
  } = _ref;
  const {
    isDesktop,
    isTablet,
    isMobile
  } = (0, _useBreakPoint.useBreakPoint)();
  const columnsInFirstRow = isDesktop ? 3 : 0;
  const firstRow = allEquals ? [] : items.slice(0, allEquals ? 0 : columnsInFirstRow) || [];
  const rest = items.slice(allEquals ? 0 : columnsInFirstRow) || [];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `articleBoxArea-container ${allEquals ? 'all-equals' : ''}`
  }, showTitle && items?.length > 0 && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-06 sia-margin-02-bottom"
  }, translate('cms.article-box-area.title')), /*#__PURE__*/_react.default.createElement("div", {
    className: "items"
  }, firstRow.map((item, index) => {
    const itemNumber = index + 1;
    const isLastInRow = itemNumber === 3;
    const isFirstInRow = itemNumber === 1;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: `item`
    }, /*#__PURE__*/_react.default.createElement(_ArticleBox.default, _extends({
      lang: lang
    }, item, {
      article_lead: typeof item.article_lead === 'object' ? '' : item.article_lead,
      isOneColumn: index > 0,
      isLastInRow: isLastInRow,
      isFirstInRow: isFirstInRow
    })));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: `items2 ${allEquals ? 'all-equals' : ''}`
  }, rest.map((item, index) => {
    const itemNumber = index + 1;
    const itemsPerRow = allEquals ? 2 : 4;
    const isLastInRow = !isMobile && itemNumber % itemsPerRow === 0;
    const isFirstInRow = allEquals && !isDesktop ? true : itemNumber % (isDesktop ? itemsPerRow : isTablet ? 2 : 3) === 1;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: `item`
    }, /*#__PURE__*/_react.default.createElement(_ArticleBox.default, _extends({
      lang: lang
    }, item, {
      article_lead: typeof item.article_lead === 'object' ? '' : item.article_lead,
      isOneColumn: true,
      isLastInRow: isMobile ? true : isLastInRow,
      isFirstInRow: isMobile ? true : isFirstInRow
    })));
  })));
};
ArticleBoxArea.propTypes = {
  items: _propTypes.default.array.isRequired,
  lang: _propTypes.default.string.isRequired
};
ArticleBoxArea.defaultProps = {};
var _default = exports.default = ArticleBoxArea;